import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { HEADER_LINKS, useIsMobile } from '../../utils'
import { StyledFooter } from '.'

const Footer: FC = () => {
  const { isMobile } = useIsMobile()

  if (isMobile && window.self !== window.top) {
    return null
  }

  return (
    <StyledFooter>
      <div className="footer">
        {HEADER_LINKS.map((link) => {
          if (link.external) {
            return (
              <a href={link.href} target="_blank" draggable={false} key={link.label}>
                {link.icon}
                <span>{link.label.toUpperCase()}</span>
              </a>
            )
          }

          return (
            <NavLink to={link.href} exact={link.exact} draggable={false} key={link.label}>
              {link.icon}
              <span>{link.label.toUpperCase()}</span>
            </NavLink>
          )
        })}
      </div>
    </StyledFooter>
  )
}

export default Footer
